import React, { useEffect } from "react";


const Themetoggle = () => {
  // Always set dark mode on mount
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
    localStorage.setItem('theme', 'dark');
  }, []);
};

export default Themetoggle;
